import { Course } from '@mc/api'

import { GlobalCarousel } from 'components/GlobalCarousel'
import { LOCATION_RELATED_COURSES } from 'components/GlobalCarousel/events'

type RelatedCoursesCarouselProps = {
  courses: Course[]
  title: string
  carouselSlug: string
  className?: string
  id?: string
}

/**
 * Exactly like RelatedCoursesCarousel, but without built-in tracking (as this one uses a different event for tracking).
 * @see RelatedCoursesCarousel
 */
export const OtherCoursesCarousel = ({
  courses,
  title,
  carouselSlug,
  ...props
}: RelatedCoursesCarouselProps) => {
  if (!courses?.length) return <></>

  return (
    <section {...props}>
      <GlobalCarousel
        carouselSlug={carouselSlug}
        tiles={courses}
        location={LOCATION_RELATED_COURSES}
        title={<h2 className='mc-text-h2 mc-text--center mc-mb-4'>{title}</h2>}
      />
    </section>
  )
}
